module.exports = __webpack_public_path__ + "img/3.f0e5d836.jpg";